module.exports = __webpack_public_path__ + "img/squad.6f207d07.png";